// extracted by mini-css-extract-plugin
module.exports = {"label":"style_label__1tU4x"};